import { render, staticRenderFns } from "./RegistrDocumentsName.vue?vue&type=template&id=29e6bb3e&"
import script from "./RegistrDocumentsName.vue?vue&type=script&lang=js&"
export * from "./RegistrDocumentsName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports